import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26aae578"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "HTMLDialogElement",
  id: "ogloba-vocher-status-modal",
  class: "modal modal-middle sm:modal-middle"
}
const _hoisted_2 = { class: "modal-box" }
const _hoisted_3 = { class: "min-w-full mt-5" }
const _hoisted_4 = { class: "border-b border-gray-200" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {ref, onMounted, toRef, watch} from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";


export default /*#__PURE__*/_defineComponent({
  __name: 'OglobaVoucherStatusModal',
  props: {
    voucherRefs: {
        required: false,
        default: [],
    },
    orderSupplierId: {
        required: false,
        default: '',
    }
},
  setup(__props) {

const props = __props;

const modalHTMLElement = ref();
const selectedUser = ref<string | null>(null);

let voucherRefs = toRef(props, "voucherRefs");
let responseOrderStatus = ref([]);

const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.attributeName === "open" && modalHTMLElement.value) {
            const isOpen = modalHTMLElement.value.open;
            const isclosed = !isOpen;
            if (isclosed) {
                selectedUser.value = null;
            }
            break; 
        }
    }
});

onMounted(() => {
    
    modalHTMLElement.value = document.querySelector(
        `#ogloba-vocher-status-modal`
    );
    if (modalHTMLElement.value) {
        observer.observe(modalHTMLElement.value, { attributes: true });

    }
});


watch(
    voucherRefs,
    (value) => {
        responseOrderStatus.value=[];
        getOrderStatus(value);
        
    })


async function getOrderStatus(
    voucherRefs
) {
    const params = {
        voucherRefs: voucherRefs,
    }
    try {
        const { data } = await ApiService.post('admin/status-ogloba-product',params );
        responseOrderStatus.value = data.data.responseOrderStatus;
        
    } catch (error) {
        swal.error('An error occurred while fetching vouchers.');
    }
}

function getLabelOrderStatus(status) {
    switch (status) {
        case '03':
            return 'Pas encore confirmée.';
        case '042':
            return 'Confirmée, la carte est prête';
        case '043':
            return 'confirmée, la carte pas encore prête';
        default:
            return '';
    }
}
const closeModalDialog = () => {
    if (modalHTMLElement.value) {
        modalHTMLElement.value.close();
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(responseOrderStatus), (voucher) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("strong", null, "Voucher No: " + _toDisplayString(voucher.orderNo), 1),
                _hoisted_5,
                _createElementVNode("strong", null, "Statut: " + _toDisplayString(getLabelOrderStatus(voucher.orderStatus)), 1),
                _createElementVNode("pre", null, _toDisplayString(voucher), 1)
              ])
            ]))
          }), 256))
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn closeModalDialog text-white",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModalDialog()))
      }, "Fermer")
    ])
  ], 512))
}
}

})